import { useTheme } from "next-themes";
import { Moon, Sun } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const isDark = theme === "dark";
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      data-testid="theme-toggle"
      className="rounded-full"
      aria-label="Toggle theme"
    >
      {isDark ? <Sun className="w-5 h-5" weight="duotone" /> : <Moon className="w-5 h-5" weight="duotone" />}
    </Button>
  );
}
